import { render, staticRenderFns } from "./ShopImagesUpload.vue?vue&type=template&id=98bbfbf8&scoped=true"
import script from "./ShopImagesUpload.vue?vue&type=script&lang=ts"
export * from "./ShopImagesUpload.vue?vue&type=script&lang=ts"
import style0 from "./ShopImagesUpload.vue?vue&type=style&index=0&id=98bbfbf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bbfbf8",
  null
  
)

export default component.exports